function redirectPage(hrefValue) {
    // Redirect to the URL
    window.location.href = hrefValue;
}

// Add a click event listener to all elements with the class 'site-header__redirect-link'
document.querySelectorAll('.site-header__redirect-link').forEach(function(element) {
    element.addEventListener('click', function(event) {
        if (event.target.classList.contains('cancel-redirect')) {
            event.preventDefault();
        } else {
            var hrefValue = this.querySelector('a').getAttribute('href');
            redirectPage(hrefValue);
        }
    });
});